import { type FC } from 'react';

import HeroesPool from './HeroesPool';
import MapPool from './MapPool';

interface Props {
  data: TeamsStatsBlockMatch;
}

const PoolBlockGrad: FC<Props> = ({ data }) => {
  if (data.videogame_slug === 'dota-2') {
    return <HeroesPool data={data} />;
  }

  if (data.videogame_slug === 'cs-go') {
    return <MapPool data={data} />;
  }

  return null;
};

PoolBlockGrad.displayName = 'PoolBlockGrad';

export default PoolBlockGrad;
